export default "__VITE_ASSET__B48_5o7y__"